import { Loader2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { useAppStore } from '@/store/useAppStore'

/**
 * フルアクセス権限がない場合のフォールバック表示
 *
 * /users/me の取得状態に応じて表示を切り替える:
 * - 未取得 / 取得中: ローディング（応答前に「権限なし」と誤表示しない）
 * - 取得失敗: 取得失敗メッセージ + 再試行ボタン
 * - 取得成功: アクセス権限なし
 */
export const FullAccessFallback = () => {
  const authSyncStatus = useAppStore((state) => state.authSyncStatus)
  const refreshUserData = useAppStore((state) => state.refreshUserData)

  if (authSyncStatus === 'idle' || authSyncStatus === 'loading') {
    return (
      <div className="flex flex-col items-center justify-center gap-3 h-screen">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
        <p className="text-muted-foreground">読み込み中...</p>
      </div>
    )
  }

  if (authSyncStatus === 'error') {
    return (
      <div className="flex flex-col items-center justify-center gap-3 h-screen">
        <p className="text-muted-foreground">ユーザー情報を取得できませんでした</p>
        <Button variant="outline" onClick={() => void refreshUserData()}>
          再試行
        </Button>
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center h-screen">
      <p className="text-muted-foreground">アクセス権限がありません</p>
    </div>
  )
}
